export default __webpack_public_path__ + "static/media/logo_noBg_v1_3.41f6d557.png";